export const AUTHOR_PAGE_ADDRESS = "https://home.cesarczyk.dev";
export const AUTHOR_PAGE_LABEL = "Cesarczyk.dev";
export const DATE = new Date().getFullYear();